import Vue from 'vue';
import Vuex from 'vuex';

import { alert } from './alert.module';
import { account } from './account.module';
import { title } from './title.module'
import { featuresModule } from './features.module'
import {visits} from './visits.module'
import {companySettingsModule} from './company_settings.module'
import { AbilityBuilder } from '@casl/ability'
import { abilityPlugin, ability as appAbility } from './ability'
import { therapistListModule } from './therapist_list.module'
export const ability = appAbility
Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        alert,
        account,
        title,
        visits,
        featuresModule,
        companySettingsModule,
        therapistListModule
    },
    actions: {
        updateAbilityPermissions({commit, state}) {
            if(state.account.permissions != null){
                var ab = AbilityBuilder.define(can => {                                                                     
                    
                    state.account.permissions.forEach(elem => {
                            
                            can('do',elem)
                        })                            
                })                
                appAbility.update(ab.rules)           
            }
        }
    },
    plugins: [abilityPlugin]
});
